import { render, staticRenderFns } from "./nest.channels.vue?vue&type=template&id=7bffda61&"
import script from "./nest.channels.vue?vue&type=script&lang=js&"
export * from "./nest.channels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "nest.channels.vue"
export default component.exports